import { useEffect, useState } from "react";
import Aviso, { mostrarAviso, ocultarAviso } from "../shared/Modules/Aviso";
import { useNavigate } from "react-router-dom";
import { obtenerDatosSolicitud } from "../shared/Functions/FuncionesAsync";
import CryptoJS from "crypto-js";

export default function Comprobante(){
    
    //#region STATE
    const [aceptado, setAceptado] = useState(false);
    const [datosSolicitud, setDatosSolicitud] = useState(null);
    //ESTADOS PARA MANEJAR AVISOS
    const[contenedorAviso, setContenedorAviso] = useState(<></>);
    //#endregion

    //#region EFFECT
    useEffect(()=>{
        const cargaAsync = async () => {
            await cargarDatosSolicitud();
        }
        validarConsultaExistente();
        cargaAsync();
    },[]);

    useEffect(() => {
        if(datosSolicitud != null){
            if(datosSolicitud.aceptado == 1){
                HandlerAceptado(true);
            }else{
                if(datosSolicitud.tipoComprobante == null){
                    cerrarConsulta();
                }
                HandlerAceptado(false);
            }
        }
    }, [datosSolicitud])
    //#endregion

    //#region NAVIGATE
    const navigate = useNavigate();
    //#endregion

    //#region  HANDLERS
    const HandlerAceptado = (valor) => {
        setAceptado(valor);
    }
    const HandlerDatosSolicitud = (valor) => setDatosSolicitud(valor);
    //#endregion

    //#region  FUNCIONES

    const cerrarConsulta = () => {
        localStorage.clear();
        navigate("/");
    }
    const validarConsultaExistente = () => {
        if(!localStorage.getItem("cod") || localStorage.getItem("cod") == ""){
            navigate("/");
        }
    }

    //FUNCIÓN PARA CARGAR DATOS DE LA SOLICITUD
    const cargarDatosSolicitud = async () => {
        const datos = {
            codigoSolicitud: localStorage.getItem("cod")
        }
        await obtenerDatosSolicitud(datos, HandlerDatosSolicitud);
    }

    //FUNCIONES PARA DESCARGAR ARCHIVOS
    const descargarPDF = () => {
        const bytes = CryptoJS.enc.Base64.parse(datosSolicitud.pdfComprobante);

        const byteArray = [];
        for (let i = 0; i < bytes.sigBytes; i++) { byteArray.push(bytes.words[i >>> 2] >>> (24 - (i % 4) * 8) & 0xff); }
        const blob = new Blob([new Uint8Array(byteArray)], { type: 'application/pdf' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = datosSolicitud.nombreArchivo;
        link.click();

        URL.revokeObjectURL(link.href);
    }
    const descargarXML = () => {
        const bytes = CryptoJS.enc.Base64.parse(datosSolicitud.xmlComprobante);

        const byteArray = [];
        for (let i = 0; i < bytes.sigBytes; i++) { byteArray.push(bytes.words[i >>> 2] >>> (24 - (i % 4) * 8) & 0xff); }
        const blob = new Blob([new Uint8Array(byteArray)], { type: 'application/zip' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = datosSolicitud.nombreArchivo;
        link.click();

        URL.revokeObjectURL(link.href);
    }
    const descargarCDR = () => {
        const bytes = CryptoJS.enc.Base64.parse(datosSolicitud.cdrComprobante);

        const byteArray = [];
        for (let i = 0; i < bytes.sigBytes; i++) { byteArray.push(bytes.words[i >>> 2] >>> (24 - (i % 4) * 8) & 0xff); }
        const blob = new Blob([new Uint8Array(byteArray)], { type: 'application/zip' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `R-${datosSolicitud.nombreArchivo}`;
        link.click();

        URL.revokeObjectURL(link.href);
    }

    //FUNCIONES PARA AVISOS
    const avisoError = (mensaje, tiempo) => {
        setContenedorAviso(<><Aviso mensaje={mensaje} tipo={'d'}/></>);
        setTimeout(() => {
            mostrarAviso();
            setTimeout(() => {
                ocultarAviso();
            }, tiempo);
        }, 10);
    }
    //#endregion

    return(<>
    {contenedorAviso}
    <div className='container' data-bs-theme='dark'>
        <div className='row p-0'>
            <div className='d-flex justify-content-center align-items-center contenedor-formulario'>
                <div className='formulario-consulta'>
                    <div className='py-3 d-flex justify-content-center'>
                        <img src="/logo-h.png" alt="Power Group System" width={'70%'}/>
                    </div>
                    {
                        aceptado ? (<>
                            <div className="p-2 text-success text-center fs-4">
                                El comprobante fue validado y aceptado
                            </div>
                            <div className="p-2">
                                <button onClick={descargarPDF} className="btn btn-primary w-100">Descargar PDF</button>
                            </div>
                            <div className="p-2">
                                <button onClick={descargarXML} className="btn btn-primary w-100">Descargar XML</button>
                            </div>
                            <div className="p-2">
                                <button onClick={descargarCDR} className="btn btn-primary w-100">Descargar CDR</button>
                            </div>
                            <div className="p-2">
                                <button onClick={cerrarConsulta} className="btn btn-secondary w-100">Consultar Nuevo Comprobante</button>
                            </div>
                        </>) : (<>
                            <div className="p-2 text-warning text-center fs-4">
                                El comprobante se está procesando, vuelva a verificar en unos minutos
                            </div>
                            <div className="p-2">
                                <button onClick={cargarDatosSolicitud} className="btn btn-primary w-100">Verificar Nuevamente</button>
                            </div>
                            <div className="p-2">
                                <button onClick={cerrarConsulta} className="btn btn-secondary w-100">Consultar Nuevo Comprobante</button>
                        </div>
                        </>)
                    }
                </div>
            </div>
        </div>
    </div>
    </>);
}